<template>
  <v-autocomplete
    class="selector-empresa"
    id='selector-empresa'
    autocomplete="off"
    label="Empresa" 
    :value="value"
    :items="items"
    item-text="name"
    :item-value="item_val"
    :return-object="return_obj"
    hide-details
    @input="myInput"
    @change="myChange"
    :readonly="readonly"
    rounded
    solo
  >
    <template v-slot:prepend>
        <label class="label-selector-empresa">Empresa</label>
    </template>
  </v-autocomplete>
</template>

<script>
export default  {
  name: 'SelectorEmpresa',
  props: {
    value: {
        type: [Object,Number],
        required: false
    },
    items:{
        type: Array,
        required: true
    },
    readonly: {
      type: Boolean,
      required: true
      },
    return_obj: {
      type: Boolean,
      required: false,
      default: true
      },
    item_val: {
      type: String,
      required: false,
      },
    },
    methods:{
      myInput(val){
        this.$emit('gotInput',val)
      },
      myChange(){
        this.$emit('changed')
      }
    },
}
</script>

<style scoped>
.selector-empresa >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.1) !important;
  padding-right: 5px !important;
}
.selector-empresa >>> .v-input__icon--append {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: rgba(245, 245, 245, 0.1) !important;  
}

.label-selector-empresa {
  font-size: 14px;
  font-weight: 600;
  padding-top: 5px;
  margin-right: 4px;
}
</style>